// Class lists shared by Radix popper content; Spellbook-internal.

/** Slides popper content in from the side it opens on. */
export const popperContentSideSlideClassNames = [
  'data-[side=bottom]:slide-in-from-top-2',
  'data-[side=left]:slide-in-from-right-2',
  'data-[side=right]:slide-in-from-left-2',
  'data-[side=top]:slide-in-from-bottom-2',
] as const;

/** Open and close motion for popper content that animates closed. */
export const popperContentMotionClassNames = [
  'data-[state=open]:animate-in',
  'data-[state=closed]:animate-out',
  'data-[state=open]:fade-in-0',
  'data-[state=closed]:fade-out-0',
  'data-[state=open]:zoom-in-95',
  'data-[state=closed]:zoom-out-95',
  ...popperContentSideSlideClassNames,
] as const;

/** Nudges popper content 1px away from its trigger on the side it opens on. */
export const popperContentSideOffsetClassNames = [
  'data-[side=bottom]:translate-y-px',
  'data-[side=left]:-translate-x-px',
  'data-[side=right]:translate-x-px',
  'data-[side=top]:-translate-y-px',
] as const;
